import FormUtils from '@/utils/FormUtils.js';
import client from '@/utils/client.js';
import IdDocumentsTypes from '@/data/id-documents-types.js';

const guaranteeObjectSetting = {
  // items without 'guaranteeTypes' are a part of form data but are not displayed as form fields.
  // type is however the base of whole form at it is always visible in form
  type: {
    defaultValue: null,
    labels: {
      default: 'Typ zabezpieczenia',
    }
  },
  number_land_mortgate_register: {
    defaultValue: '',
    labels: {
      default: 'Numer księgi wieczyste',
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  pledge_type: {
    defaultValue: null,
    labels: {
      default: 'Rodzaj zastawu',
    },
    guaranteeTypes: ['Zastaw rejestrowy']
  },
  device_name: {
    defaultValue: '',
    labels: {
      default: 'Nazwa urządzenia',
    },
    guaranteeTypes: ['Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'pledge_type',
      value: ['DEVICE']
    }
  },
  car_brand: {
    defaultValue: '',
    labels: {
      default: 'Marka',
    },
    guaranteeTypes: ['Zastaw rejestrowy'],
    condition: {
      field: 'pledge_type',
      value: ['CAR', 'VEHICLE', 'DEVICE']
    }
  },
  car_model: {
    defaultValue: '',
    labels: {
      default: 'Model',
    },
    guaranteeTypes: ['Zastaw rejestrowy'],
    condition: {
      field: 'pledge_type',
      value: ['CAR', 'VEHICLE', 'DEVICE']
    }
  },
  car_register: {
    defaultValue: '',
    labels: {
      default: 'Nr rejestracyjny',
    },
    guaranteeTypes: ['Zastaw rejestrowy'],
    condition: {
      field: 'pledge_type',
      value: ['CAR', 'VEHICLE']
    }
  },
  car_registration_number: {
    defaultValue: '',
    labels: {
      default: 'Numer dowodu rej.',
    },
    guaranteeTypes: ['Zastaw rejestrowy'],
    condition: {
      field: 'pledge_type',
      value: ['CAR', 'VEHICLE']
    }
  },
  car_vin: {
    defaultValue: '',
    labels: {
      default: 'Nr VIN',
      DEVICE: 'Nr seryjny'
    },
    guaranteeTypes: ['Zastaw rejestrowy'],
    condition: {
      field: 'pledge_type',
      value: ['CAR', 'VEHICLE', 'DEVICE']
    }
  },
  production_year: {
    defaultValue: '',
    labels: {
      default: 'Rok produkcji'
    },
    guaranteeTypes: ['Zastaw rejestrowy'],
    condition: {
      field: 'pledge_type',
      value: ['CAR', 'VEHICLE']
    }
  },
  value: {
    defaultValue: '',
    labels: {
      default: 'Wartość'
    },
    guaranteeTypes: ['Zastaw rejestrowy']
  },
  shares_value: {
    defaultValue: '',
    labels: {
      default: 'Wartość nominalna jednego udziału'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  shares_number: {
    defaultValue: '',
    labels: {
      default: 'Ilość udziałów, na których jest zastaw'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  other: {
    defaultValue: '',
    labels: {
      default: 'Inne'
    },
    guaranteeTypes: ['Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki']
  },
  number_land: {
    defaultValue: '',
    labels: {
      default: 'Numer działki'
    },
    guaranteeTypes: ['Dom', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  street: {
    defaultValue: '',
    labels: {
      default: 'Ulica'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Inne']
  },
  house_number: {
    defaultValue: '',
    labels: {
      default: 'Nr budynku'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Inne']
  },
  flat_number: {
    defaultValue: '',
    labels: {
      default: 'Nr lokalu'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  postcode: {
    defaultValue: '',
    labels: {
      default: 'Kod pocztowy'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Inne']
  },
  city: {
    defaultValue: '',
    labels: {
      default: 'Miasto'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Inne']
  },
  province: {
    defaultValue: '',
    labels: {
      default: 'Województwo'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  county: {
    defaultValue: '',
    labels: {
      default: 'Powiat'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  community: {
    defaultValue: '',
    labels: {
      default: 'Gmina'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  district: {
    defaultValue: '',
    labels: {
      default: 'Dzielnica'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  court_city: {
    defaultValue: '',
    labels: {
      default: 'Siedziba Sądu'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  court_jurisdiction: {
    defaultValue: '',
    labels: {
      default: 'Sąd właściwy'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  mortgage_amount: {
    defaultValue: 0,
    labels: {
      default: 'Wartość nieruchomości'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  court_department_number: {
    defaultValue: '',
    labels: {
      default: 'Numer wydziału KW'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  area: {
    defaultValue: '',
    labels: {
      default: 'Powierzchnia'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne']
  },
  company: {
    defaultValue: '',
    labels: {
      default: 'Nazwa spółki/firmy'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  nip: {
    defaultValue: '',
    labels: {
      default: 'NIP'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  regon: {
    defaultValue: '',
    labels: {
      default: 'Regon'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  krs: {
    defaultValue: '',
    labels: {
      default: 'KRS'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  company_street: {
    defaultValue: '',
    labels: {
      default: 'Ulica'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  company_house_number: {
    defaultValue: '',
    labels: {
      default: 'Nr budynku'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  company_flat_number: {
    defaultValue: '',
    labels: {
      default: 'Nr lokalu'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  company_postcode: {
    defaultValue: '',
    labels: {
      default: 'Kod pocztowy'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  company_city: {
    defaultValue: '',
    labels: {
      default: 'Miasto'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  company_province: {
    defaultValue: '',
    labels: {
      default: 'Województwo'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  shares_belong_to: {
    defaultValue: null,
    labels: {
      default: 'Osoba, której przysługują udziały'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki']
  },
  shares_guarantor_id: {
    defaultValue: 0,
    labels: {
      default: 'Poręczyciel'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['guarantor']
    }
  },
  shares_person_firstname: {
    defaultValue: '',
    labels: {
      default: 'Imię'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_secondname: {
    defaultValue: '',
    labels: {
      default: 'Drugie imię'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_surname: {
    defaultValue: '',
    labels: {
      default: 'Nazwisko'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_pesel: {
    defaultValue: '',
    labels: {
      default: 'PESEL'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_id_card_type: {
    defaultValue: 'id',
    labels: {
      default: 'Typ dokumentu tożsamości'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_id_card: {
    defaultValue: '',
    labels: {
      default: 'Nr dokumentu tożsamości'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_street: {
    defaultValue: '',
    labels: {
      default: 'Ulica'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_house_number: {
    defaultValue: '',
    labels: {
      default: 'Nr budynku'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_flat_number: {
    defaultValue: '',
    labels: {
      default: 'Nr lokalu'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_postcode: {
    defaultValue: '',
    labels: {
      default: 'Kod pocztowy'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_city: {
    defaultValue: '',
    labels: {
      default: 'Miasto'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_email: {
    defaultValue: '',
    labels: {
      default: 'E-mail'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_phone: {
    defaultValue: '',
    labels: {
      default: 'Nr telefonu'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_marital_status: {
    defaultValue: '',
    labels: {
      default: 'Stan cywilny'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_belong_to',
      value: ['other']
    }
  },
  shares_person_property_separation: {
    defaultValue: '',
    labels: {
      default: 'Rozdzielność majątkowa'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_person_marital_status',
      value: [1]
    }
  },
  shares_person_marital_status_other: {
    defaultValue: '',
    labels: {
      default: 'Opis stanu cywilnego'
    },
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    condition: {
      field: 'shares_person_marital_status',
      value: [2]
    }
  },
  is_burdens_on_property: {
    defaultValue: false,
    labels: {
      default: 'Inne zobowiązania (kredyty, pożyczki)',
      'Zastaw rejestrowy': 'Inne obciążenia/ograniczenia',
      'Zastaw rejestrowy na udziałach spółki': 'Inne obciążenia/ograniczenia'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki', 'Inne']
  },
  burdens_description: {
    defaultValue: '',
    labels: {
      default: 'Opis obciążenia/ograniczenia'
    },
    condition: {
      field: 'is_burdens_on_property',
      value: [true]
    },
    guaranteeTypes: ['Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki', 'Inne']
  },
  burdens_amount: {
    defaultValue: '',
    labels: {
      default: 'Kwota obciążeń'
    },
    condition: {
      field: 'is_burdens_on_property',
      value: [true]
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki', 'Inne']
  },
  property_owner: {
    defaultValue: '',
    labels: {
      default: 'Właściciele'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki', 'Inne']
  },
  comments: {
    defaultValue: '',
    labels: {
      default: 'Komentarze'
    },
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki', 'Inne']
  },
  client_id: {
    defaultValue: null,
  },
  id: {
    defaultValue: null,
  },
  files: {
    defaultValue: []
  },
  files_to_delete: {// if a previously saved file is to be deleted push it's id to this array
    defaultValue: []
  },
  docs: {
    defaultValue: []
  }
};

const types = [{
  label: 'Dom',
  value: 'Dom'
}, {
  label: 'Lokal mieszkalny',
  value: 'Lokal mieszkalny'
}, {
  label: 'Lokal użytkowy',
  value: 'Lokal użytkowy'
}, {
  label: 'Działka',
  value: 'Działka'
},
{
  label: 'Zastaw rejestrowy',
  value: 'Zastaw rejestrowy'
},
{
  label: 'Zastaw rejestrowy na udziałach spółki',
  value: 'Zastaw rejestrowy na udziałach spółki'
},
{
  label: 'Inne',
  value: 'Inne'
}]

const shareBelongToOptions = [
  {
    value: 'client',
    label: 'Pożyczkobiorca'
  },
  {
    value: 'guarantor',
    label: 'Poręczyciel'
  },
  {
    value: 'other',
    label: 'Inna osoba'
  }
]

const guaranteeFilesTypes = [
  {
    fileType: 'registration_certificate',
    guaranteeTypes: ['Zastaw rejestrowy'],
    label: 'Dowód rej.'
  }, {
    fileType: 'insurance_policy',
    guaranteeTypes: ['Zastaw rejestrowy'],
    label: 'Polisa ubezpieczeniowa'
  }, {
    fileType: 'registration_notice',
    guaranteeTypes: ['Zastaw rejestrowy'],
    label: 'Postanowienie o wpisie do rejestru'
  }, {
    fileType: 'proof_pledge_entry',
    guaranteeTypes: ['Zastaw rejestrowy'],
    label: 'Skan dowodu z wpisem zastawu'
  }, {
    fileType: 'basis_of_acquisition',
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne'],
    label: 'Podstawa nabycia'
  }, {
    fileType: 'mortgage_register',
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Inne'],
    label: 'Odpis księgi wieczystej'
  }, {
    fileType: 'file_of_buildings',
    guaranteeTypes: ['Dom', 'Lokal użytkowy'],
    label: 'Wypis z kartoteki budynków, jeśli nieruchomość jest zabudowana'
  }, {
    fileType: 'land_register',
    guaranteeTypes: ['Dom', 'Lokal użytkowy', 'Działka'],
    label: 'Wypis z rejestru gruntów wraz z wyrysem z mapy ewidencyjnej (nie starszy niż 3 miesiące)'
  }, {
    fileType: 'krs_excerpt',
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    label: 'Odpis z KRS'
  }, {
    fileType: 'consent_establish_pledge',
    guaranteeTypes: ['Zastaw rejestrowy na udziałach spółki'],
    label: 'Zgoda na ustanowienie zastawu'
  }, {
    fileType: 'space_management',
    guaranteeTypes: ['Dom', 'Lokal użytkowy', 'Działka'],
    label: 'Zaświadczenie o przeznaczeniu w planie zagospodarowania przestrzennego'
  }, {
    fileType: 'other_files',
    guaranteeTypes: ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka', 'Zastaw rejestrowy', 'Zastaw rejestrowy na udziałach spółki', 'Inne'],
    label: 'Inne'
  }
]

const pledgeTypes = [{
  label: 'Samochód',
  value: 'CAR'
}, {
  label: 'Pojazd',
  value: 'VEHICLE'
}, {
  label: 'Urządzenie',
  value: 'DEVICE'
}]

// Statusy dla nieruchomości: Dom, Lokal mieszkalny, Lokal użytkowy, Działka
const guaranteeStatusesRealEstate = [
  {
    class: 'text-primary',
    label: 'Złożono wniosek',
    value: 'entry_received'
  },
  {
    class: 'text-danger',
    label: 'Niezgodne z wnioskiem',
    value: 'proposal_inconsistent'
  },
  {
    class: 'text-success',
    label: 'Ustanowiona',
    value: 'established'
  },
  {
    class: 'text-success',
    label: 'Wpisana',
    value: 'excerpt_received'
  },
  {
    class: 'text-warning',
    label: 'Zwolniona',
    value: 'released'
  },
  {
    class: 'text-secondary',
    label: 'Wykreślona',
    value: 'deleted'
  }
]

// Statusy dla zastawów: Zastaw, Zastaw rejestrowy, Inne
const guaranteeStatusesPledge = [
  {
    class: 'text-primary',
    label: 'Złożono wniosek',
    value: 'entry_received'
  },
  {
    class: 'text-danger',
    label: 'Niezgodne z wnioskiem',
    value: 'proposal_inconsistent'
  },
  {
    class: 'text-success',
    label: 'Ustanowiony',
    value: 'established'
  },
  {
    class: 'text-success',
    label: 'Wpisany',
    value: 'excerpt_received'
  },
  {
    class: 'text-warning',
    label: 'Zwolniony',
    value: 'released'
  },
  {
    class: 'text-secondary',
    label: 'Wykreślony',
    value: 'deleted'
  }
]

const guaranteeStatuses = [...guaranteeStatusesRealEstate]

class GuaranteeUtils {

  static getGuaranteeObjectSetting () {
    return guaranteeObjectSetting;
  }

  static getDefaultGuaranteeObject () {
    const guaranteeObject = {};

    for (const key in guaranteeObjectSetting) {
      if (guaranteeObjectSetting.hasOwnProperty(key)) {
        guaranteeObject[key] = guaranteeObjectSetting[key].defaultValue;
      }
    }

    return JSON.parse(JSON.stringify(guaranteeObject));
  }

  static getAvailableTypes () {
    return types;
  }

  static getAvailablePledgeTypes () {
    return pledgeTypes;
  }

  static getShareBelongToOptions () {
    return shareBelongToOptions;
  }

  static getAvailableFilesTypes () {
    return guaranteeFilesTypes;
  }

  static getAvailableStatuses () {
    return guaranteeStatuses;
  }

  static getFilesTypesForGuarantee (guaranteeType) {
    return guaranteeFilesTypes.filter(item => item.guaranteeTypes.includes(guaranteeType)).map(item => item.fileType);
  }

  static getFormFields () {
    const guaranteeObject = {};

    for (const key in guaranteeObjectSetting) {
      if (guaranteeObjectSetting.hasOwnProperty(key) && guaranteeObjectSetting[key].guaranteeTypes) {
        guaranteeObject[key] = guaranteeObjectSetting[key].guaranteeTypes;
      }
    }

    return JSON.parse(JSON.stringify(guaranteeObject));
  }

  static getAvailableStatusesForType (type) {
    const realEstateTypes = ['Dom', 'Lokal mieszkalny', 'Lokal użytkowy', 'Działka'];

    if (realEstateTypes.includes(type)) {
      return guaranteeStatusesRealEstate;
    }

    return guaranteeStatusesPledge;
  }

  static getFieldsForType (guaranteeType, guaranteeObj = null, onlyVisible = false) {
    if (!guaranteeType) {
      return [];
    }

    let output = [];
    let allFields = Object.keys(guaranteeObjectSetting);

    for (let i = 0; i < allFields.length; i++) {
      let currentFieldObj = guaranteeObjectSetting[allFields[i]];
      if (onlyVisible && !('labels' in currentFieldObj)) {
        continue;
      }
      if (!currentFieldObj.guaranteeTypes || currentFieldObj.guaranteeTypes.includes(guaranteeType)) {
        if (!currentFieldObj.condition || !guaranteeObj) {
          output.push(allFields[i]);
        } else {
          if (currentFieldObj.condition.value.includes(guaranteeObj[currentFieldObj.condition.field])) {
            output.push(allFields[i]);
          } else if (!(currentFieldObj.condition.field in guaranteeObj) && !output.includes(allFields[i])) {
            // this is fallback for guarantees created when there was no pledge_type
            output.push(allFields[i]);
          }
        }
      }
    }

    return output;
  }

  static saveGuarantee (guaranteeData, clientID, successActionHandler, failActionHandler) {
    try {
      var data = new FormData();
      let __guarantee = _.clone({ ...guaranteeData, client_id: clientID });
      let availableFileTypes = this.getFilesTypesForGuarantee(__guarantee.type);
      if (!Array.isArray(__guarantee.docs)) {
        __guarantee.docs = [];
      }

      __guarantee.files = __guarantee.docs.reduce(function (filtered, option) {
        if (option.file && (availableFileTypes.includes(option.type) || (option.type === '' && availableFileTypes.includes('other_files')))) {
          filtered.push({ file: option.file, type: option.type, description: option.description });
        }
        return filtered;
      }, []);

      let fieldsForGuarantee = this.getFieldsForType(__guarantee.type, __guarantee);
      __guarantee.is_burdens_on_property = +__guarantee.is_burdens_on_property;
      let defaultObj = this.getDefaultGuaranteeObject();
      let currentFields = Object.keys(__guarantee);

      for (let i = 0; i < currentFields.length; i++) {
        // reset to default values of fields that are used in current guarantee type
        if (!fieldsForGuarantee.includes(currentFields[i]) && (currentFields[i] in defaultObj)) {
          __guarantee[currentFields[i]] = defaultObj[currentFields[i]];
        }
      }

      Vue.appendFormdataFiles(data, __guarantee);

      FormUtils.submit(this, {
        endpoint: '/api/payment-guarantees/save-payment-guarantee',
        formData: data,
        successTitle: 'Zabezpieczenie zostało zapisane.',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapis zabezpieczenia nie powiódł się. Spróbuj ponownie.',
        successAction: (response) => {
          if (!successActionHandler) {
            return;
          }
          successActionHandler(response);
        },
        failAction: (error) => {
          if (!failActionHandler) {
            return;
          }
          failActionHandler(error);
        },
      });
    } catch (error) {
      if (!failActionHandler) {
        console.error(error);
        return;
      }
      failActionHandler(error);
    }
  }

  static getFieldLabel (guarantee, field) {
    if (!guaranteeObjectSetting[field].labels) {
      console.error('no label for field ', field);
      return '-';
    }

    if (guaranteeObjectSetting[field].condition) {
      if (Object.keys(guaranteeObjectSetting[field].labels).length === 1) {
        return guaranteeObjectSetting[field].labels.default;
      }

      let conditionField = guaranteeObjectSetting[field].condition.field;
      let conditionValue = guarantee[conditionField];

      return guaranteeObjectSetting[field].labels[conditionValue] || guaranteeObjectSetting[field].labels.default;
    }

    return guaranteeObjectSetting[field].labels[guarantee.type] || guaranteeObjectSetting[field].labels.default;
  }

  static getFieldValueForDisplay (guarantee, field, guarantors = []) {
    if (field == 'shares_belong_to') {
      let optionFound = shareBelongToOptions.find(item => item.value === guarantee.shares_belong_to);
      if (optionFound) {
        return optionFound.label;
      }
      return '-';
    }

    if (field == 'pledge_type') {
      let optionFound = pledgeTypes.find(item => item.value === guarantee.pledge_type);
      if (optionFound) {
        return optionFound.label;
      }
      return '-';
    }

    if (field === 'is_burdens_on_property' || field === 'shares_person_property_separation') {
      return guarantee[field] ? 'Tak' : 'Nie';
    }

    if (field == 'shares_person_id_card_type') {
      let foundType = IdDocumentsTypes.find(item => item.value === guarantee[field]);
      return foundType ? foundType.label : '-';
    }

    if (field == 'shares_person_marital_status') {
      let statusFound = client._marital_statuses.find(item => item.value === guarantee[field]);
      return statusFound ? statusFound.name : '-'
    }

    if (field === 'shares_guarantor_id') {
      if (!guarantee[field]) {
        return '-';
      }

      let guarantor = guarantors.find(item => item.id === guarantee[field]);

      return guarantor ? guarantor.name : '-';
    }

    return guarantee[field] || '-';
  }
}

export default GuaranteeUtils;
